"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reducer = _interopRequireDefault(require("./componentshell/reducer"));

var _reducer2 = _interopRequireDefault(require("./fulfillmentconfigurationlist/reducer"));

var _reducer3 = _interopRequireDefault(require("./versionslist/reducer"));

// This is a top level object containing all reducers throughout the app.
// When authoring a new reducer make sure to import it here and add it
// to the default object.
var _default = {
  componentShellReducer: _reducer["default"],
  fulfillmentConfigurationListReducer: _reducer2["default"],
  versionsListReducer: _reducer3["default"]
};
exports["default"] = _default;